import { CardNumberElement } from "@stripe/react-stripe-js";
import { Stripe, StripeElements } from "@stripe/stripe-js";

import { Dispatch, GetState } from "common/types/redux";

import {
  createPaymentMethodFinished,
  createPaymentMethodStarted,
  subscriptionUpdateSucceeded
} from "seneca-common/features/subscriptions/state";
import { updatePaymentMethod } from "seneca-common/features/subscriptions/state/service";
import { logMessage } from "seneca-common/utils/sentry/logError";

type Options = {
  stripe: Stripe;
  stripeElements: StripeElements;
  onSuccess: (() => void) | null | undefined;
  onSubmitFailure: (message: string | null | undefined) => void;
};

export function handleUpdatePaymentMethodFormSubmit(
  subscriptionId: string,
  cardHolderEmail?: string,
  postcode?: string,
  // @ts-ignore optional-arg
  { stripe, stripeElements, onSuccess, onSubmitFailure }: Options
) {
  return async function (dispatch: Dispatch, getState: GetState) {
    dispatch(createPaymentMethodStarted());
    onSubmitFailure(null);

    if (!stripe) {
      logMessage(
        "Unable to create stripe source as the stripe library has not loaded"
      );
      onSubmitFailure("Sorry, something went wrong");
      return;
    }

    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: stripeElements.getElement(CardNumberElement)!,
      billing_details: {
        address: {
          postal_code: postcode
        }
      }
    });

    if (error) {
      logMessage("Error received when attempting to create stripe source", {
        error
      } as any);
      onSubmitFailure(error.message);
      return;
    }

    dispatch(createPaymentMethodFinished());

    const response = await dispatch(
      updatePaymentMethod(subscriptionId, paymentMethod!.id, cardHolderEmail)
    );

    const state = getState();

    if (
      response &&
      response.subscriptionId &&
      subscriptionUpdateSucceeded(state, response.subscriptionId)
    ) {
      onSuccess && onSuccess();
    }
  };
}
